<template>
  <div :class="$style.container" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div :class="$style.header">
      <span :class="$style.edit" @click.stop="handleEditClick" v-if="is_edit">编辑</span>
      <span :class="$style.edit" @click.stop="handleEditClick" v-if="!is_edit">详情</span>
      <span :class="['iconfont', 'icon-touxiang', $style.avatar]" style="margin-right: 8px"></span>
      <div :class="$style.userInfo">
        <span style="font-size: 18px">{{ info.last_name }}</span>
        <span v-if="info.primary === 'T'" style="
            font-size: 12px;
            display: inline-block;
            margin-left: 4px;
            height: 16px;
            padding: 2px 5px;
            background: #ff9901;
            line-height: 16px;
            color: #fff;
            font-weight: 400;
            border-radius: 4px;
          ">主要</span>
        <!-- <p v-if="info.gender && info.birthday && info.phone">
          {{ info.gender | filtersex }} {{ info.birthday | filtertime
          }}<i :class="['iconfont', 'icon-tel03', $style.tel]"></i>{{ info.phone }}
        </p>
        <p v-if="!info.gender && info.birthday && info.phone">
          {{ info.birthday | filtertime
          }}<i :class="['iconfont', 'icon-tel03', $style.tel]"></i>{{ info.phone }}
        </p> -->
        <p v-if="info.phone">
          <i :class="['iconfont', 'icon-tel03', $style.tel1]"></i>{{ info.phone }}
        </p>
      </div>
    </div>
    <div :class="$style.body">
      <p>
        职务:
        <span :class="$style.date" v-if="info.title">{{ info.title }}</span>
        <span :class="$style.date" v-else style="color: red">暂无</span>
      </p>
    </div>
    <el-dialog title="" :visible.sync="modelManger" :show-close="false" @close="closeModal" id="addPeopleDialog">
      <div slot="title" class="dialog-footer" style="
          display: flex;
          justify-content: space-between;
          border-bottom: 2px dashed #e7eaec;
          padding: 10px 0px;
        ">
        <span style="color: #3998f7; font-size: 22px; padding-top: 5px" v-if="is_edit">编辑管理人员</span>
        <span style="color: #3998f7; font-size: 22px; padding-top: 5px" v-if="!is_edit">管理人员详情</span>
        <span>
          <el-button v-if="is_edit" :class="$style.my_button" @click="removeJuManger" icon="el-icon-delete"
            style="background: #ed3b3f; border-color: #ed3b3f" type="primary" size="small">移除</el-button>
          <el-button v-if="is_edit" @click="editJuManger" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="closeModal" size="small">取消</el-button>
        </span>
      </div>
      <el-form class="formSave" :model="formManger" style="width: 80%; margin: auto" label-position="left"
        ref="editPeopleForm" hide-required-asterisk>
        <el-form-item label="所属辖区" label-width="100px">
          <el-row>
            <el-col style="color: #3998f7" :push="2">
              {{ formManger.territory_name }}&nbsp;&nbsp;{{
              formManger.territory_code
              }}
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="管理人员" label-width="100px">
          <el-row>
            <el-col :span="22" style="color: #3998f7" :push="2">
              {{ formManger.manger }}</el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="设为主要" prop="primary" label-width="100px">
          <el-row>
            <el-col style="color: #3998f7" :span="22" :push="2">
              <el-switch v-model="formManger.primary" active-value="T" inactive-value="F" active-color="#6BC235"
                :disabled="!is_edit"></el-switch>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
  import http from "../../APIService/http";
  import { bus } from "../../router/index";
  export default {
    props: {
      info: {
        type: Object,
        default: () => { },
      },
      options: {
        type: Array,
        default: () => [],
      },
      quitReasons: {
        type: Array,
        default: () => [],
      },
      is_edit: {
        type: Boolean,
        default: () => true,
      }
    },
    data() {
      return {
        formManger: {
          territory_name: "",
          territory_code: "",
          territory_id: "",
          manger: "",
          primary: "F",
        },
        modelManger: false,
        loading: false,
        data: {},
      };
    },
    computed: {
      primary() {
        return this.info.primary;
      },
    },
    watch: {
      primary(val) {
        this.formManger.primary = val;
      },
    },
    filters: {
      filtersex: function (o) {
        if (o && o === "T") {
          return "女";
        } else if (o && o === "M") {
          return "男";
        } else {
          return "";
        }
      },
      filtertime: function (a) {
        var o = a.trim();
        if (o) {
          console.log(o);
          var str =
            o.split("")[0] + o.split("")[1] + o.split("")[2] + o.split("")[3];
          var curDate = new Date();
          var curYear = curDate.getFullYear();
          return Number(curYear - str) + "岁";
        } else {
          return "";
        }
      },
    },
    methods: {
      // 编辑按钮
      handleEditClick() {
        this.modelManger = true;
      },
      async editJuManger() {
        let data = { ...this.info };
        data.territory_id = this.data.territory_id;
        data.primary = this.formManger.primary;

        await http.post("/wapi/JurActive/editPeople", data).then((res) => {
          if (res.success === true) {
            this.$message({
              type: "success",
              message: "保存成功",
            });
            let obj = this.$store.getters.getDataInfo;
            if (data.primary === "T") {
              obj.salseList.forEach((item) => {
                item.primary = "";
              });
            }
            for (let i = 0; i < obj.salseList.length; i++) {
              if (data.user_id === obj.salseList[i].manager_id) {
                obj.salseList[i].primary = data.primary;
              }
            }
            let length = obj.salseList.length;
            this.closeModal();
            this.$emit("getPeople");
            bus.$emit("changeTreeList", new Date());
            bus.$emit("changeList", new Date());
            bus.$emit("getPeopleLength", length);
          }
        });
      },
      async removeJuManger() {
        let data = { ...this.info };
        data.territory_id = this.data.territory_id;

        await http.post("/wapi/JurActive/removePeople", data).then((res) => {
          if (res.success === true) {
            this.$message({
              type: "success",
              message: "移除成功",
            });
            let obj = this.$store.getters.getDataInfo;
            for (let i = 0; i < obj.salseList.length; i++) {
              if (data.user_id === obj.salseList[i].manager_id) {
                obj.salseList.splice(i, 1)
              }
            }
            let length = obj.salseList.length;
            this.closeModal();
            this.$emit("getPeople");
            bus.$emit("changeTreeList", new Date());
            bus.$emit("changeList", new Date());
            bus.$emit("getPeopleLength", length);
          }
        });
      },
      // 关闭模态框
      closeModal() {
        this.modelManger = false;
        this.init()
      },
      init() {
        this.data = this.$store.getters.getDataInfo;
        this.formManger.territory_name = this.data.territory_name;
        this.formManger.territory_id = this.data.territory_id;
        this.formManger.manger = this.info.alias;
        this.formManger.primary = this.info.primary || "F";
        this.formManger.territory_code = this.data.territory_code
          ? `(${this.data.territory_code})`
          : "";
      },
    },
    mounted() {
      this.init();
      // console.log(this.info,111)
      if (this.info.category === "SYSTEM") {
        this.info.category = "地区经理";
      } else {
        this.info.category = "地区经理";
      }
    },
  };
</script>
<style lang="scss" module>
  @import "../../assets/css/default";

  .container {
    border: 1px solid #979797;
    width: 300px;
    height: 80px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 20px;

    .my_button {
      background-color: #ed3b3f;
      border-color: #ed3b3f;
    }

    .my_button:hover {
      background-color: #f06e70;
      border-color: #f06e70;
    }

    .header {
      padding: 10px;

      &:after {
        display: block;
        content: "";
        overflow: hidden;
        clear: both;
      }

      .avatar {
        font-size: 40px;
        color: #f49557;
        float: left;
      }

      .edit {
        color: #4a90e2;
        font-size: 14px;
        float: right;
        cursor: pointer;
      }

      .userInfo {
        span {
          font-size: 14px;
          font-weight: bold;
          color: #2a363b;
          vertical-align: middle;
        }

        .frozen {
          font-size: 12px;
          color: #fff;
          padding: 3px;
          background: #d1021b;
          border-radius: 3px;
        }

        .tip {
          font-size: 12px;
          color: #fff;
          padding: 3px;
          background: #ff9801;
          border-radius: 5px;
        }

        p {
          margin: 10px 0px 0px;
          color: #717d84;
          opacity: 0.6;

          .tel {
            font-size: 16px;
            margin-right: 3px;
            margin-left: 8px;
          }

          .tel1 {
            font-size: 16px;
            margin-right: 3px;
            margin-left: 0px;
          }
        }
      }
    }

    .body {
      p {
        margin: 0 10px 10px 16px;
        color: #9da4ad;
        font-size: 15px;
        font-weight: normal;

        .date {
          margin-left: 4px;
          color: #a2e065;

          &:after {
            display: inline-block;
            content: "";
            overflow: hidden;
            clear: both;
          }
        }
      }
    }

    .modal {
      .title {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;

        >span {
          color: #3998f7;
          font-size: $fontSize;
        }
      }

      .phone {

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none !important;
          margin: 0;
        }
      }
    }
  }
</style>

<style scoped>
  .a_modal>>>form {
    text-align: left;
    width: 90%;
    margin: 0 auto;
  }

  .a_modal>>>.el-dialog__header {
    border-bottom: 2px dotted #e7eaec;
  }

  .a_modal>>>.el-form-item__label {
    color: #000000;
    font-size: 16px;
    /* width: 140px!important; */
    text-align: right;
  }

  .a_modal>>>.el-select {
    width: 100%;
  }

  .a_modal>>>.el-form-item__content {
    color: #4a90e2;
    font-size: 16px;
    font-weight: bold;
  }
</style>


// WEBPACK FOOTER //
// src/pages/jurisdiction/boxItemactive.vue